const contextMenu = [
  {
    label: 'Edit',
    value: 'edit',
    image:"assets/images/virtusa-icons/edit.svg",
    imageStyle:{
     "margin-right":"6px"
    }
  },
  {
    label: 'Duplicate',
    value: 'duplicate',
    image:"assets/images/virtusa-icons/duplicate.svg",
    imageStyle:{
     "margin-right":"6px"
    }
  },
  {
    label: 'Copy & move to...',
    value: 'copy',
    image:"assets/images/virtusa-icons/copy_icon.svg",
    imageStyle:{
     "margin-right":"6px"
    }
  }
];


export const testSuiteTableColumns: any = [
  {
    key: "checkbox",
    display_name: "",
    headerStyles: {
      background: "#7593F2",
      width: "5%",
    },
    _config: {
      type: "checkbox-conditional",
      displayInColumn: false,
      isConditionalCheck: true,
      conditionalCheck: { key: "level", value: 0 },
    },
  },
  {
    key: "expand",
    showExpand: true,
    headerStyles: {
      background: "#7593F2",
      width: "30px",
    },
  },
  {
    display_name: "Test Script",
    key: "name",
    hideForChildren: true,
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
    },
  },
  {
    display_name: "Input/Output",
    key: "inputOutput",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
    },
    _config: {
      type: "lozenge",
      classMapping: {
        Input: "input-class",
        Output: "output-class",
      },
    },
  },
  {
    display_name: "Parameter Name",
    key: "paramName",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
    },
  },
  {
    display_name: "Parameter Type",
    key: "paramType",
    headerStyles: {
      background: "#7593F2",
      width: "15%",
      color: "#ffffff",
    },
  },
  {
    display_name: "Test Case ID",
    key: "tcgTestCaseResultName",
    headerStyles: {
      background: "#7593F2",
      width: "15%",
      color: "#ffffff",
    },
    _config: {
      type: "link",
      displayInColumn: false,
    },
  },
  {
    display_name: "",
    key: "map",
    _config: {
      type: "conditional-button",
      name: "Open",
      isImage: true,
      imgSrc: "../../../../assets/images/table/table-item-open.svg",
      classNames: "btn-accello-light open-btn ",
      isConditionalCheck: true,
      conditionalCheck: { key: "level", value: 0 },
    },
    headerStyles: {
      background: "#7593F2",
      width: "10%",
    },
  },
  // {
  //   key: "edit",
  //   display_name: "",
  //   cellStyles: { "font-size": "13px" },
  //   headerStyles: {
  //     background: "#7593F2",
  //     color: "#FFFFFF",
  //     width: "4%",
  //     borderRadius: "0 6px 0 0"
  //   },
  //   _config: {
  //     type: "conditional-svg",
  //     value: "../../../../assets/images/table/table-item-edit.svg",
  //     classNames: "btn-accello-light",
  //     isConditionalCheck: true,
  //     conditionalCheck: { key: "level", value: 0 },
  //     isClickable: "true",
  //   },
  // },
  {
    display_name: "",
    key: "context_menu",
    _config: {
      type: 'contextMenu-conditional',
      icon: 'more_vert',
      options: contextMenu,
      isConditionalCheck: true,
      conditionalCheck: { key: "level", value: 0 },
    },
    iconStyles: {
      color: 'grey'
    },
    headerStyles: {
      background: "#7593F2",
      width: '45px'
    }
  }
];

